<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('closeModal')">
                <div class="row">
                    <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
                    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
                        <div class="modal-container" @click.stop>
                            <!-- <div
                                class="modal-header"
                                style="justify-content: flex-end"
                            >
                                <button
                                    type="button"
                                    class="close"
                                    @click="$emit('closeModal')"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div> -->

                            <div class="modal-body">
                                <!-- <h2 class="title">
                                    Edit User
                                    <span style="color: #bdbdbd">{{
                                        form.username
                                    }}</span>
                                </h2> -->
								<div class="row">
                                    <div class="col-8">
                                        <h2
                                            class="title"
                                            style="margin-bottom: 20px"
                                        >
                                            Edit User</span>
                                        </h2>
                                    </div>
                                    <div class="offset-3 col-1">
                                        <button
                                            type="button"
                                            class="close"
                                            @click="$emit('closeModal')"
                                            style="
                                                font-size: 20px;
                                                color: #db5757;
                                                opacity: 1;
                                            "
                                        >
                                            <i class="fa fa-times"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="row  ">
                                    <div
                                        class="col-xs-12 col-sm-6 col-md-6 col-lg-6 first-field"
                                    >
                                        <div class="input-group">
                                            <label class="label"
                                                >Full Name<span
                                                    style="color: red"
                                                    >*</span
                                                ></label
                                            >
                                            <input
                                                class="input--style-4"
                                                type="text"
                                                name="name"
                                                v-model="form.name"
                                            />
                                        </div>
                                    </div>
                                    <div
                                        class="col-xs-12 col-sm-6 col-md-6 col-lg-6 second-field" 
                                    >
                                        <div class="input-group">
                                            <label class="label"
                                                >Status<span style="color: red"
                                                    >*</span
                                                ></label
                                            >
                                            <MultiSelect
                                                v-model="form.status"
                                                :options="[0, 1]"
                                                :custom-label="
                                                    (opt) =>
                                                        opt
                                                            ? 'Active'
                                                            : 'Inactive'
                                                "
                                                :allow-empty="false"
                                                placeholder="Choose Status"
                                            ></MultiSelect>
                                        </div>
                                    </div>
                                </div>
                                <div class="row  ">
									<div
                                        class="col-xs-12 col-sm-6 col-md-6 col-lg-6 first-field"
                                    >
                                        <div class="input-group">
                                            <label class="label"
                                                >NPK<span
                                                    style="color: red"
                                                    >*</span
                                                ></label
                                            >
                                            <input
                                                class="input--style-4"
                                                type="text"
                                                name="name"
                                                v-model="form.npk"
                                            />
                                        </div>
                                    </div>
                                    <div
                                        class="col-xs-12 col-sm-6 col-md-6 col-lg-6 second-field"
                                    >
                                        <div class="input-group">
                                            <label class="label"
                                                >Type<span style="color: red"
                                                    >*</span
                                                ></label
                                            >
                                            <MultiSelect
                                                v-model="form.type"
                                                :options="[
                                                    'USER_DEALER',
                                                    'SUPER_ADMIN',
                                                    'USER_MAIN_DEALER'
                                                ]"
                                                :allow-empty="false"
                                                disabled
                                                placeholder="Choose Type"
                                            ></MultiSelect>
                                        </div>
                                    </div>
                                    
                                </div>
								<div
									class="w-100"
                                    v-if="form.type != 'SUPER_ADMIN'"
								>
									<div class="input-group">
										<label class="label"
											>{{
												form.type ==
												'USER_MAIN_DEALER'
													? 'Region'
													: 'Permission'
											}}<span style="color: red"
												>*</span
											></label
										>
										<MultiSelect
											v-if="
												form.type !=
												'USER_MAIN_DEALER'
											"
											v-model="form.permission"
											:options="
												options.dealer.map(
													(x) => x.loc_code
												)
											"
											:custom-label="
												(opt) =>
													options.dealer.find(
														(x) =>
															x.loc_code ==
															opt
													).showName
											"
											:allow-empty="false"
											:multiple="false"
											placeholder="Choose Permssion"
											:internal-search="false"
											@search-change="searchDealer"
										></MultiSelect>

										<MultiSelect
											v-else
											v-model="form.permission"
											:options="
												options.region.map(
													(x) => x.region_code
												)
											"
											:custom-label="
												(opt) =>
													options.region.find(
														(x) =>
															x.region_code ==
															opt
													).fullname
											"
											:allow-empty="false"
											:multiple="false"
											placeholder="Choose Region"
										></MultiSelect>
									</div>
								</div>
                                <div class="outerBoxPass">
                                    <div
                                        class="innerBoxPass paddingInnerInnerBox whiteBg"
                                    >
                                        <div
                                            class="row"
                                            @click="
                                                collapsedPass = !collapsedPass
                                            "
                                        >
                                            <div class="col-6 left">
                                                <p class="subPartTitle">
                                                    Reset Password
                                                </p>
                                            </div>
                                            <div class="col-6 text-right">
                                                <button
                                                    type="button"
                                                    class="btn btn-link collapseButton"
                                                    v-if="collapsedPass"
                                                >
                                                    +
                                                </button>
                                                <button
                                                    type="button"
                                                    class="btn btn-link collapseButton"
                                                    v-else
                                                >
                                                    -
                                                </button>
                                            </div>
                                        </div>
                                        <div class="row" v-if="!collapsedPass">
                                            <div
                                                class="col-xs-12 col-sm-12 col-md-6 col-lg-6 first-field"
                                            >
                                                <div class="input-group">
                                                    <label class="label"
                                                        >Password</label
                                                    >
                                                    <input
                                                        class="input--style-4"
                                                        type="password"
                                                        name="password"
                                                        v-model="form.password"
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                class="col-xs-12 col-sm-12 col-md-6 col-lg-6 second-field"
                                            >
                                                <div class="input-group">
                                                    <label class="label"
                                                        >Re-type Password</label
                                                    >
                                                    <input
                                                        class="input--style-4"
                                                        type="password"
                                                        name="retype_password"
                                                        v-model="
                                                            retype_password
                                                        "
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Button Starts -->
                                <div class="row">
                                    <!-- <div class="col text-center">
                                        <button
                                            type="button"
                                            class="btn btn-outline-danger"
                                            style="font-size: 140%"
                                            @click="$emit('closeModal')"
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-primary ml-5"
                                            style="font-size: 150%"
                                            @click="submitForm()"
                                        >
                                            Edit
                                        </button>
                                    </div> -->
									<div class="offset-lg-8 col-lg-2 col-12 mt-3">
										<button
                                            type="button"
                                            class="btn btn-dark-blue-outline w-100"
                                            @click="$emit('closeModal')"
                                        >
                                            Batal
                                        </button>
									</div>
									<div class="col-lg-2 col-12 mt-3">
										<button
                                            type="button"
                                            class="btn btn-green w-100"
                                            @click="submitForm()"
                                        >
                                            Edit User
                                        </button>
									</div>
                                </div>
                                <!-- Button Ends -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
            </div>
        </div>
    </transition>
</template>

<script>
import MultiSelect from 'vue-multiselect';
import modulesList from './modulesList.json';

export default {
    data() {
        return {
            mobile: this.isMobile(),
            collapsedPass: true,
            options: {
                dealer: []
            },
            form: {
                name: '',
                username: '',
                password: '',
                status: '',
                permission: [],
                id: null,
				npk: null
            },
            retype_password: '',
            moduleConfig: null,
            selectModule: [],
            structure: [],
            selected: [],
            username: '',
            selectedDealer: null
        };
    },
    props: ['user_id'],
    directives: {
        indeterminate: function (el, binding) {
            el.indeterminate = Boolean(binding.value);
        }
    },
    components: {
        MultiSelect
    },
    async mounted() {
        // this.generateStructure()
        // console.log(t)
        //
        

        this.fetchUserData();
        this.loadRegion();
    },
    watch: {},
    methods: {
        async searchDealer(query) {
            let dealerList = await this.$store.getters.getDealer();
            dealerList = dealerList.filter(
                (x) =>
                    x.showName.toLowerCase().includes(query.toLowerCase()) &&
                    query.length > 1
            );
            this.options.dealer = dealerList;
        },
        getDealerList() {},
        async loadRegion() {
            try {
                let response = await this.$http.get('/api/master/region');

                let data = response.data.data.map((x) => {
                    return {
                        ...x,
                        fullname: x.region_code + ' - ' + x.name
                    };
                });

                this.$set(this.options, 'region', data);
            } catch (err) {
                console.log(err);
            }
        },
        openBox(index) {
            if (this.structure[index].children == null) return;
            for (var i in this.moduleConfig) {
                if (i == index)
                    this.moduleConfig[index].boxOpen =
                        !this.moduleConfig[index].boxOpen;
                else this.moduleConfig[i].boxOpen = false;
            }
        },
        fetchUserData() {
            this.$http
                .get('/api/detail-user?id=' + this.user_id)
                .then(async (resp) => {
                    var data = resp.data.data;

                    this.form.id = this.user_id;

                    this.form.name = data.name;
                    this.form.username = data.username;
                    this.form.status = data.status == 'Active' ? 1 : 0;
                    this.form.type = data.type;
                    
                    if(data.type == 'USER_DEALER') {
                        let dealerList = await this.$store.getters.getDealer();
                        dealerList = dealerList.filter(
                            (x) =>
                                x.showName.toLowerCase().includes(data.permission.toLowerCase())
                        );
                        // console.log(dealerList)
                        if(dealerList.length == 0) this.form.permission = null
                        else this.form.permission = data.permission;
                    }
                    else
                        this.form.permission = data.permission
                    


					this.form.npk = data.npk;
                    // console.log(data.permission)
                    this.selectedDealer =
                        this.$store.getters.getFilterOptions.dealer.find(
                            (x) => x.loc_code == data.permission
                        );
                    this.options.dealer = [this.selectedDealer];
                    // this.form.modules = data.modules;

                    // this.username = data.username;
                    // this.type = data.type;
                })
                .then(() => {
                    var modules = this.structure.map((x) => {
                        return x.children
                            ? x.children.map((y) => y.id)
                            : [x.id];
                    });

                    for (var i in this.form.modules) {
                        for (var j in modules) {
                            if (
                                modules[j].indexOf(
                                    parseInt(this.form.modules[i])
                                ) != -1
                            ) {
                                console.log(this.form.modules[i]);
                                this.selected[j].push(this.form.modules[i]);
                            }
                        }
                    }
                    // this.selected[parseInt(this.form.modules[i].slice(0,2))-1].push(this.form.modules[i])
                    this.cleanUp();
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        cleanUp() {
            for (var i in this.moduleConfig) {
                if (this.structure[i].children) {
                    if (
                        this.structure[i].children.length ==
                        this.selected[i].length
                    ) {
                        //All Checked
                        this.moduleConfig[i].indeterminate = false;
                        this.moduleConfig[i].checked = true;
                    } else if (this.selected[i].length == 0) {
                        //None Checked
                        this.moduleConfig[i].indeterminate = false;
                        this.moduleConfig[i].checked = false;
                    } else {
                        //Partial Checked
                        this.moduleConfig[i].indeterminate = true;
                        this.moduleConfig[i].checked = true;
                    }
                }
            }
        },
        validateForm() {
            var valid = true;
            var error = [];

            if (this.form.name == '' || this.form.name == null) {
                //Full Name [Required]
                valid = false;
                error.push('Full Name is a required Field!');
            }

            if (this.form.username == '' || this.form.username == null) {
                //Username [Required]
                valid = false;
                error.push('Username is a required Field!');
            }

            if (
                (this.form.password != '' && this.form.password != null) ||
                (this.retype_password != '' && this.retype_password != null)
            ) {
                if (this.form.password !== this.retype_password) {
                    //Password and Retype Password Not The Same
                    valid = false;
                    error.push('Password and Re-Type Password does not match!');
                }
            } else if (this.form.password == '') {
                delete this.form.password;
            }

            if(this.form.type != 'SUPER_ADMIN') {
                if (this.form.permission == '' || this.form.permission == null) {
                    //Permission [Required]
                    valid = false;
                    error.push('Permission is a required Field!');
                }

            }
            
            // console.log(this.form)

            // if(this.form.modules.length == 0){//Modules [Required]
            //   valid = false;
            //   error.push('Modules has to have at least one module selected');
            // }

            if (!valid) this.$emit('triggerAlert', !valid, error);
            else return valid;
        },
        async submitForm() {
            let vm = this;
            if (await vm.validateForm()) {
                this.$http
                    .put('/api/update-user', this.form)
                    .then((resp) => {
                        vm.$emit('triggerAlert', false, [
                            `User ${vm.form.username} has been successfully modified`
                        ]);
                    })
                    .catch((err) => {
                        // console.log(err.response.data);
                        vm.$emit(
                            'triggerAlert',
                            true,
                            err.data.message
                        );
                    });
            }
        }
    }
};
</script>

<style>
/* ==========================================================================
    #FORM made by Colorlib (https://colorlib.com)
    ========================================================================== */
input {
    outline: none;
    margin: 0;
    border: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    width: 100%;
    font-size: 14px;
    font-family: inherit;
}

.input--style-4 {
    line-height: 40px;
    background: #fff;
    /* -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08); */
    border : 1px solid #CECECE;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    padding: 0 20px;
    font-size: 16px;
    color: #666;
    -webkit-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #666;
}

.input--style-4:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #666;
    opacity: 1;
}

.input--style-4::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #666;
    opacity: 1;
}

.input--style-4:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #666;
}

.input--style-4:-ms-input-placeholder {
    /* Microsoft Edge */
    color: #666;
}

.label {
    font-size: 12px;
    color: #5D5D5D;
    text-transform: capitalize;
    display: block;
    margin-bottom: 5px;
}

.radio-container {
    display: inline-block;
    position: relative;
    padding-left: 30px;
    cursor: pointer;
    font-size: 16px;
    color: #666;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.radio-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
    background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
    display: block;
}

.radio-container .checkmark:after {
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    background: #57b846;
}

.checkmark {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #e5e5e5;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
    content: '';
    position: absolute;
    display: none;
}

.input-group {
    position: relative;
    /* margin-bottom: 22px; */
    padding: 20px;
}

.input-group-icon {
    position: relative;
}

.input-icon {
    position: absolute;
    font-size: 18px;
    color: #999;
    right: 18px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    cursor: pointer;
}

/* ==========================================================================
       #TITLE made by Colorlib (https://colorlib.com)
       ========================================================================== */
.title {
    font-size: 16px;
    color: #525252;
    margin-bottom: 40px;
    text-align: center;
}

.modal-body {
    max-height: 80vh;
    overflow-y: auto;
    overflow-x: auto;
}
.innerBox {
    padding: 1.5rem 1.5rem 1.5rem 2.25rem;
    border: 1px solid #eeeeee;
    border-radius: 5px;
    background-color: white;
    box-shadow: 2px 2px 5px #e0e0e0;
}
.custom-control {
    margin-bottom: 0;
}

.hoverable:hover {
    cursor: pointer;
}

/* Reset Password Start */
.paddingInnerInnerBox {
    padding: 10px 15px;
}
.outerBoxPass {
    padding-top: 20px;
	padding-bottom: 20px;
}
.innerBoxPass {
    border: 1px solid #bdbdbd;
    border-radius: 5px;
    /* box-shadow: 10px 10px 20px #e0e0e0; */
}
.paddingInnerInnerBox p {
    margin: 0;
}
.subPartTitle {
    font-size: 110%;
    padding: 6px 12px;
    color: #757575;
}
.collapsed:hover {
    text-decoration: underline;
}
.collapseButton {
    color: black;
}
/* Reset Password End */
.input-group {
    padding-left: 0;
    padding-right: 0;
}

.first-field {
    padding-right: 3.5% !important;
}

.second-field {
    padding-left: 3.5% !important;
}
</style>
